import Anthropic from '@anthropic-ai/sdk';
import { LLMProvider } from './base';

export class AnthropicProvider extends LLMProvider {
  constructor(apiKey, config = {}) {
    super(apiKey, config);
    this.client = new Anthropic({ 
      apiKey, 
      dangerouslyAllowBrowser: true 
    });
    this.model = config.model || 'claude-sonnet-4-20250514';
  }

  async chat(messages, systemPrompt = '') {
    return this.retryWithBackoff(async () => {
      const response = await this.client.messages.create({
        model: this.model,
        max_tokens: this.config.maxTokens || 2000,
        system: systemPrompt,
        messages: [{
          role: 'user',
          content: messages
        }]
      });

      return response.content[0].text;
    });
  }

  async chatMultiTurn(messages, systemPrompt = '') {
    return this.retryWithBackoff(async () => {
      const response = await this.client.messages.create({
        model: this.model,
        max_tokens: this.config.maxTokens || 4096,
        system: systemPrompt,
        messages: messages.map(m => ({ role: m.role, content: m.content }))
      });
      return response.content[0].text;
    });
  }

  async chatMultiTurnStream(messages, systemPrompt = '', onChunk = () => {}) {
    const stream = this.client.messages.stream({
      model: this.model,
      max_tokens: this.config.maxTokens || 4096,
      system: systemPrompt,
      messages: messages.map(m => ({ role: m.role, content: m.content }))
    });

    let fullText = '';
    for await (const event of stream) {
      if (event.type === 'content_block_delta' && event.delta?.type === 'text_delta') {
        const text = event.delta.text;
        fullText += text;
        onChunk(text);
      }
    }
    return fullText;
  }

  async chatWithImage(images, textPrompt, systemPrompt = '') {
    return this.retryWithBackoff(async () => {
      const imageBlocks = images.map(img => ({
        type: 'image',
        source: { type: 'base64', media_type: img.mimeType, data: img.base64 }
      }));
      const response = await this.client.messages.create({
        model: this.model,
        max_tokens: 4096,
        system: systemPrompt,
        messages: [{
          role: 'user',
          content: [...imageBlocks, { type: 'text', text: textPrompt }]
        }]
      });
      return response.content[0].text;
    });
  }

  validateApiKey() {
    return this.apiKey && this.apiKey.startsWith('sk-ant-');
  }

  getModelName() {
    return 'Claude (Anthropic)';
  }
}
